module.exports = __webpack_public_path__ + "img/emoji_41.e1517ed8.png";